export const focusFirstElement = (element: HTMLElement, customSelector?: string) => {
    if (!element) {
        return
    }

    const focusableElements = Array.from(element.querySelectorAll(customSelector ||
        'button:not([disabled]), ' +
        'a[href]:not([disabled]), ' +
        'input:not([disabled]), ' +
        'textarea:not([disabled]), ' +
        'select:not([disabled])')) as HTMLElement[]


    // Filter to only visible elements
    const visibleElements = focusableElements.filter((el) => {
        const style = window.getComputedStyle(el)
        const rect = el.getBoundingClientRect()

        // radio are hidden by default but should be focusable
        if (el instanceof HTMLInputElement && el.type === 'radio') {
            return true
        }

        return (
            style.display !== 'none' &&
            style.visibility !== 'hidden' &&
            style.opacity !== '0' &&
            rect.width > 0 &&
            rect.height > 0
        )
    })

    // Focus first visible element
    if (visibleElements.length > 0) {
        visibleElements[0]?.focus()
    }
}
